import styled from 'styled-components';

import { ExternalLinkButton } from '../../../../../components/ExternalLinkButton';

export const StyledSalesforceActivityContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  margin-top: 4px;
`;

export const StyledViewInSalesforceButton = styled(ExternalLinkButton)`
  margin-left: auto;
`;
